import React from 'react';
import styled from 'styled-components';
import { Box, Card, Flex, Image, Link, Relative, Text } from 'pcln-design-system';
import { HotelsOutline, FlightsOutline, CarsOutline, PackagesOutline } from '@pcln/brand';
import { products, productsType } from '../../constants';
const StyledImage = /*#__PURE__*/styled(Image).withConfig({
  displayName: "TripCard__StyledImage",
  componentId: "sc-1xovvqz-0"
})(["object-fit:cover;"]);
const CustomTruncate = /*#__PURE__*/styled(Text).withConfig({
  displayName: "TripCard__CustomTruncate",
  componentId: "sc-1xovvqz-1"
})(["width:100%;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;"]);
const BackUpImage = ({
  type
}) => {
  let IconType;
  if (type === 'STAY') {
    IconType = HotelsOutline;
  } else if (type === 'DRIVE') {
    IconType = CarsOutline;
  } else if (type === 'FLY') {
    IconType = FlightsOutline;
  } else if (type === 'PACKAGE') {
    IconType = PackagesOutline;
  }
  return IconType ? React.createElement(Card, {
    height: '100%',
    borderRadius: '8px',
    borderWidth: 0,
    color: 'primary.light'
  }, React.createElement(Flex, {
    width: ['48px', '88px'],
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center'
  }, React.createElement(IconType, {
    color: 'primary',
    size: '32px'
  }))) : null;
};
export const TripCard = ({
  trip,
  actualCheckStatusUrl
}) => {
  var _a;
  let imageSrc, name, productName, brandImageUrl;
  const {
    type,
    title,
    dateHeader
  } = trip;
  name = title;
  const isPackage = type === productsType.PACKAGE;
  if (isPackage) {
    const {
      pkgType
    } = trip;
    productName = pkgType;
  } else {
    const {
      brandImageUrl: rcBrandImageUrl,
      type,
      header,
      imageUrl,
      scheduleInfo
    } = trip;
    imageSrc = imageUrl || ((_a = scheduleInfo === null || scheduleInfo === void 0 ? void 0 : scheduleInfo[0]) === null || _a === void 0 ? void 0 : _a.companyLogoUrl);
    productName = products[type];
    name = name || header;
    brandImageUrl = rcBrandImageUrl;
  }
  return React.createElement(Text, {
    lineHeight: '16px'
  }, React.createElement(Card, {
    borderRadius: 16,
    p: 2,
    mb: 2,
    width: 1,
    color: 'background.lightest'
  }, React.createElement(Flex, {
    width: 1
  }, React.createElement(Box, null, React.createElement(Relative, {
    height: '100%',
    width: 1
  }, React.createElement(Flex, {
    height: '100%',
    width: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  }, type ? imageSrc ? React.createElement(Flex, {
    width: '82px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  }, React.createElement(StyledImage, {
    src: imageSrc,
    width: type === 'STAY' ? '82px' : null,
    borderRadius: '8px',
    height: type === 'STAY' ? '100%' : '29px'
  }), brandImageUrl ? React.createElement(Image, {
    src: brandImageUrl,
    height: '13px'
  }) : null) : React.createElement(BackUpImage, {
    type: type
  }) : null))), React.createElement(Flex, {
    flexDirection: 'column',
    pl: 3
  }, productName && React.createElement(Text, {
    color: 'text.light',
    fontSize: 0,
    mb: 1
  }, productName), name && React.createElement(Flex, null, React.createElement(CustomTruncate, {
    fontSize: 1,
    fontWeight: 'bold',
    m: 0,
    mb: 1
  }, name)), dateHeader && React.createElement(Text, {
    fontSize: 0,
    color: 'text',
    mb: 1
  }, dateHeader), actualCheckStatusUrl && React.createElement(Link, {
    target: '_blank',
    href: actualCheckStatusUrl
  }, React.createElement(Text, {
    fontSize: 0
  }, "Select Trip"))))));
};